import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
];
import { FacilityViewAllComponent } from "./facility-view-all.component";
routes.push({ path: 'facilities', component: FacilityViewAllComponent});

export const FacilityRoutingProvider = RouterModule.forRoot(routes, { useHash: true });